import React, { FC, MouseEvent, PropsWithChildren } from 'react';
import cls from 'classnames';

import { Link } from '../../../../atoms/Link';

import styles from './index.module.sass';

interface IParentProps {
  className?: string;
  href?: string;
  onClickButton: ( event: MouseEvent<HTMLButtonElement> ) => void;
}

export const Parent: FC<PropsWithChildren<IParentProps>> = ({
  children,
  className,
  href,
  onClickButton,
}) =>
  href ? (
    <Link className={cls( styles.parent, className )} href={href}>
      {children}
    </Link>
  ) : (
    <button
      className={cls( styles.button, styles.parent, className )}
      type="button"
      onClick={onClickButton}
    >
      {children}
    </button>
  );
